import { render, staticRenderFns } from "./MoodleButton.vue?vue&type=template&id=7ae3fb5f&scoped=true&"
import script from "./MoodleButton.vue?vue&type=script&lang=js&"
export * from "./MoodleButton.vue?vue&type=script&lang=js&"
import style0 from "./MoodleButton.vue?vue&type=style&index=0&id=7ae3fb5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae3fb5f",
  null
  
)

export default component.exports